import React from "react";
import { RentReportingListScreenContainer } from "src/containers";

export const RentReportingListScreen = () => {
  return <RentReportingListScreenContainer />;
};
